<template>
    <div>
        <action-bar>
        </action-bar>
        <main class="content">
            <div v-if="partner !== false">
                <h1>Partner bearbeiten<br>
                    <small class="text-muted">{{partner.name.text}}</small>
                </h1>
                <text-input :value="partner.name" label="Name" ref="name"></text-input>
                <long-text-input :value="partner.description" label="Text" ref="description"></long-text-input>
                <div class="form-group">
                    <label>URL</label>
                    <input v-model="partner.url" class="form-control">
                </div>
                <file-input v-model="partner.image" label="Logo" type="image"></file-input>
                <div class="admin-info">
                    <ul>
                        <li>
                            Logo bitte als PNG mit transparentem Hintergrund hochladen. Zudem Logo so zuschneiden, dass rund um das Logo keine Ränder mehr sind.
                        </li>
                        <li>
                            Der Partner kann von der Bearbeitungsseite des Projekts aus verlinkt werden. Die Reihenfolge ist nicht beeinflussbar.
                        </li>
                    </ul>
                </div>
                <hr>
                <button class="btn btn-primary" @click="save">Save</button>
            </div>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        partner: false
      }
    },
    mounted () {
      axios
        .get('/api/' + store.state.language + '/partner/' + this.$route.params.partnerId)
        .then(({data}) => {
          this.partner = data.result
        })
    },
    methods: {
      save () {
        let form = new FormData();
        if (this.partner.image && this.partner.image.id) {
          form.append('edit_partner[image]', this.partner.image.id)
        } else {
          form.append('edit_partner[image]', "")
        }
        form.append('edit_partner[url]', this.partner.url);

        this.$refs.name.save()
        this.$refs.description.save()
        axios
          .post('/api/' + store.state.language + '/partner/' + this.$route.params.partnerId + "/edit", form);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/partner/Edit.vue